export default (props, vars) =>
  props?.['student']?.finalPresentation.source === 'google_drive';
